import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Card } from '@/components/Card';
import { Chip, ChipRow } from '@/components/ChipRow';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import type { AdapterStatus } from '@shared/types';

export function MorePage() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [adapters, setAdapters] = useState<AdapterStatus[]>([]);
  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    api.adapters().then((d) => {
      setAdapters(d.adapters);
      setNotice(d.notice);
    });
  }, []);

  return (
    <div className="space-y-4">
      <Card>
        <h2 className="font-display text-[30px] leading-none text-navy">More</h2>
        <ChipRow className="mt-3">
          <Chip tone={user?.mode === 'guest' ? 'brass' : 'navy'}>{user?.mode}</Chip>
          <Chip>{user?.displayName}</Chip>
        </ChipRow>
        <div className="mt-4 grid grid-cols-2 gap-2 text-sm font-semibold">
          <Link className="rounded-card border border-line px-3 py-3" to="/profile">
            Profile
          </Link>
          <Link className="rounded-card border border-line px-3 py-3" to="/admin">
            Admin
          </Link>
          <Link className="rounded-card border border-line px-3 py-3" to="/wallet">
            Wallet
          </Link>
          <button
            className="rounded-card border border-line px-3 py-3 text-left"
            onClick={async () => {
              await api.logout();
              setUser(null);
              navigate('/');
            }}
          >
            Sign out
          </button>
        </div>
      </Card>
      <Card>
        <h3 className="font-display text-2xl text-navy">Deferred adapters</h3>
        <p className="mt-2 text-sm text-muted">{notice}</p>
        <ul className="mt-3 space-y-3">
          {adapters.map((adapter) => (
            <li key={adapter.id}>
              <ChipRow>
                <Chip tone={adapter.wired ? 'success' : adapter.mock ? 'alert' : 'line'}>
                  {adapter.wired ? 'Wired' : 'Mock'}
                </Chip>
                <Chip>{adapter.name}</Chip>
              </ChipRow>
              <p className="mt-1 text-[13px] text-muted">{adapter.note}</p>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
